import {ActionTree} from "vuex";
import axios, {AxiosResponse} from "axios";
import {RootState} from "@/store/types";
import {StatisticState, CdpDetailFilterParams, CdpDetailItem, CdpDetailItemInfo, CdpGroupFilterParams} from "./types";
import {serializeParams} from "@/utils/data-helper";

export const actions: ActionTree<StatisticState, RootState> = {
  async getCdpStatisticDetail({commit}, params: CdpDetailFilterParams): Promise<AxiosResponse> {
    commit('setLoading', true);
    try {
      const response: AxiosResponse<{events: CdpDetailItem[]}> = await axios({
        url: '/stats-api/detail/cdp/events',
        params: params,
        paramsSerializer: serializeParams
      });
      let events = response.data?.events ?? [];
      if (params.page_number > 1) {
        commit('pushCdpStaticDetail', events);
      } else {
        commit('setCdpStaticDetail', events);
      }
      return response;
    } catch (error) {
      throw error;
    } finally {
      commit('setLoading', false);
    }
  },

  async getCdpStatisticDetailInfo({commit}, id: string): Promise<AxiosResponse> {
    commit('setLoading', true);
    try {
      const response: AxiosResponse<CdpDetailItemInfo> = await axios({url: `/stats-api/detail/cdp/events/${encodeURIComponent(id)}`});
      return response;
    } catch (error) {
      throw error;
    } finally {
      commit('setLoading', false);
    }
  },

  async exportCdpStatisticDetail({commit}, filter: CdpDetailFilterParams): Promise<AxiosResponse> {
    commit('setLoading', true);
    try {
      const response: AxiosResponse<{status: string}> = await axios({url: '/stats-api/detail/cdp/events/export', params: filter});
      return response;
    } catch (error) {
      throw error;
    } finally {
      commit('setLoading', false);
    }
  },
  async getCdpStatisticGroup({commit}, filter: CdpGroupFilterParams) {
    commit('setLoading', true);
    try {
      const response = await axios({url: '/stats-api/group/cdp/events', params: filter});
      commit('setCdpStatisticGroup', response.data.events);
      return response;
    } finally {
      commit('setLoading', false);
    }
  },
  async exportCdpStatisticGroup({commit}, filter: CdpGroupFilterParams) {
    commit('setLoading', true);
    try {
      const response = await axios({url: '/stats-api/group/cdp/events/export', params: filter});
      return response;
    } finally {
      commit('setLoading', false);
    }
  },
};
